import CT from '@marketplace-ai/tags';
import { useSelector } from '@xstate/react';
import { useLocation, useNavigate } from 'react-router';
import type { ActorRefFrom } from 'xstate';
import { buildRegistrationPath, readRegistrationReturnTo } from '~/routing/registrationReturnTo';
import { paths } from '~/routing/routes';
import { Container, Footer, FormContent, Header } from '../components/Layout';
import { WELCOME_FORM_ID } from '../constants';
import { WelcomeForm } from '../forms/WelcomeForm';
import { providerRegistrationView } from '../registration-view.machine';
import type { RegistrationViewContext } from '../types';

interface PageProps {
  actorRef: ActorRefFrom<typeof providerRegistrationView>;
  viewContext: RegistrationViewContext;
}

const welcomeTags = CT.registration.welcome;
const footerTags = {
  back: welcomeTags.backButton,
  loadingBar: welcomeTags.loadingBar,
};

export function WelcomePage({ actorRef, viewContext }: PageProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const welcomeForm = useSelector(actorRef, (snapshot) => snapshot.context.welcomeForm);

  const handleBack = () => {
    navigate(
      buildRegistrationPath(paths.register.roleSelect, readRegistrationReturnTo(location.search))
    );
  };

  return (
    <Container>
      <Header
        cyTag={welcomeTags.title}
        title="Welcome to MedCredVault"
        subtitle="Let's get your account set up."
      />

      <FormContent>
        <WelcomeForm actorRef={actorRef} defaultValues={welcomeForm} />
      </FormContent>

      <Footer
        cyTags={footerTags}
        handleBack={handleBack}
        loadingPercent={5}
        next={{ formId: WELCOME_FORM_ID, cyTag: welcomeTags.nextButton }}
      />
    </Container>
  );
}
